export const version = "json-wallets/5.5.0";
